import { AsyncPipe } from '@angular/common';
import { Component, HostBinding, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '@bcef/ia-components/buttons';
import { PanelModule } from '@bcef/ia-components/panel';
import { RadioButtonModule } from '@bcef/ia-components/radio-button';
import { DataLayered } from '@difa/ia-data-layer';
import { TranslateModule } from '@ngx-translate/core';

import { SuccessionFacade } from '@features/succession/succession.facade';
import { InvalidControlScrollDirective } from '@shared/directives/invalid-control-scroll.directive';

import { HeirInformationFormComponent } from './heir-information-form/heir-information-form.component';
import { InheritanceInformationFacade } from './inheritance-information.facade';

@DataLayered('dataLayer.inheritanceInformation')
@Component({
  selector: 'ia-succession-inheritance-information',
  templateUrl: './inheritance-information.component.html',
  imports: [
    AsyncPipe,
    ButtonModule,
    ReactiveFormsModule,
    TranslateModule,
    HeirInformationFormComponent,
    InvalidControlScrollDirective,
    PanelModule,
    RadioButtonModule,
  ],
  standalone: true,
})
export class InheritanceInformationComponent {
  @HostBinding('class') public classAttribute = 'tw-flex tw-flex-col tw-mb-4 tw-mx-0 sm:tw-mx-24';

  protected readonly successionFacade = inject(SuccessionFacade);

  protected readonly inheritanceFacade = inject(InheritanceInformationFacade);
}
